import React, { Fragment, useMemo } from 'react'
import { withTranslation } from 'react-i18next'

const PrivacyStatement = ({ t, i18n }) => {
  return (
    <div>
      <h2>{t('privacy_notice.page_title')}</h2>
      <p>
        {t('privacy_notice.para1')}
        <em>{t('privacy_notice.para1_freedom_of_info')}</em>
        {t('privacy_notice.para1_ou')}
        <em>{t('privacy_notice.para1_foipop')}</em>
        {t('privacy_notice.para1_other')}
      </p>
      <p>
        {t('privacy_notice.para2')}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={i18n.language === 'en' ? 'https://beta.novascotia.ca/privacy' : 'https://beta.novascotia.ca/fr/enonce-de-confidentialite'}
        >
          {' '}
          {t('privacy_notice.privacy_statement_link')}
          <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
        </a>
        .{t('privacy_notice.para3')}
        <a href="mailto:askus@novascotia.ca">
          {t('privacy_notice.ask_novascotia')}
          <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
        </a>
        {t('privacy_notice.para3_other')}
      </p>
    </div>
  )
}

export default withTranslation('common')(PrivacyStatement)
